<template>
  <div class="part">
    <!--number-->
    <div class="number">05</div>
    <div class="head">
      <div class="title">小程序核心使用场景</div>
      <div class="mark">享有微信10亿月活用户</div>
    </div>
    <div class="con">
      <tab class="tab" @tab="tab" ref="tab">
        <div class="point" slot="tab-point">
          <div class="point-item" data-index="0" @mouseover="handleMouseEnter">
            <div class="icon icon1"></div>
            <div class="item-text">微信搜索</div>
          </div>
          <div class="point-item" data-index="1" @mouseover="handleMouseEnter">
            <div class="icon icon2"></div>
            <div class="item-text">线下扫码</div>
          </div>
          <div class="point-item" data-index="2" @mouseover="handleMouseEnter">
            <div class="icon icon3"></div>
            <div class="item-text">推荐给好友</div>
          </div>
          <div class="point-item" data-index="3" @mouseover="handleMouseEnter">
            <div class="icon icon4"></div>
            <div class="item-text">小程序列表</div>
          </div>

          <div class="point-item" data-index="4" @mouseover="handleMouseEnter">
            <div class="icon icon5"></div>
            <div class="item-text">附近小程序</div>
          </div>

          <div class="point-item" data-index="5" @mouseover="handleMouseEnter">
            <div class="icon icon6"></div>
            <div class="item-text">公众号关联</div>
          </div>

          <div class="point-item" data-index="6" @mouseover="handleMouseEnter">
            <div class="icon icon7"></div>
            <div class="item-text">公众号文章</div>
          </div>

          <div class="point-item" data-index="7" @mouseover="handleMouseEnter">
            <div class="icon icon8"></div>
            <div class="item-text">分享到群</div>
          </div>

          <div class="point-item" data-index="8" @mouseover="handleMouseEnter">
            <div class="icon icon9"></div>
            <div class="item-text">聊天顶部</div>
          </div>
        </div>
        <div class="content" slot="tab-content">
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua1.png" alt="" class="item-img" v-show="tabActive == 0">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua2.png" alt="" class="item-img" v-show="tabActive == 1">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua3.png" alt="" class="item-img" v-show="tabActive == 2">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua4.png" alt="" class="item-img" v-show="tabActive == 3">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua5.png" alt="" class="item-img" v-show="tabActive == 4">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua6.png" alt="" class="item-img" v-show="tabActive == 5">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua7.png" alt="" class="item-img" v-show="tabActive == 6">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua8.png" alt="" class="item-img" v-show="tabActive == 7">
            </transition>
          </div>
          <div class="content-item">
            <transition name="slide">
              <img src="~../../assets/images/05chahua9.png" alt="" class="item-img" v-show="tabActive == 8">
            </transition>
          </div>
        </div>
      </tab>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Tab from '../common/tab'
export default {
  data() {
    return {
      tabActive: 0
    }
  },
  methods: {
    tab(index){
      this.tabActive = index
    },
    handleMouseEnter(e){
      let index = +(e.currentTarget.getAttribute('data-index'))
      this.$refs.tab.tab(index)
    }
  },
  components: {
    Tab
  }
}
</script>

<style scoped lang="scss">
@import "../../common/common.scss";
.part{
  width: 100%;
  min-width: $min-width;
  max-width: 1200px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.0;
  margin-top: 210px;
  position: relative;
  .number{
    font-size: 180px;
    font-weight: bold;
    color:$theme-color;
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: -100px;
    @media screen and (min-width: $min-width) and(max-width: 1200px) {
      left: 10px;
    }
  }
  .head{
    padding-left: 50px;
    .title{
      font-size: 48px;
      font-weight: bold;
      color: $theme-color;
      margin-bottom: 32px;
    }
    .mark{
      font-size: 36px;
      color: #2cbb58;
      margin-bottom: 100px;
    }
  }
  .con{
    height: 540px;
    position: relative;
    .point{
      position: absolute;
      right:0;
      width: 540px;
      .point-item{
        float: left;
        width: 180px;
        height: 180px;
        overflow: hidden;
        text-align: center;
        color:#fff;
        .item-text{
          user-select: none;
          opacity: 0.8;
        }
        .icon{
          width: 70px;
          height: 70px;
          @include bg-center;
          margin: 32px auto 28px;
        }
        .icon1{
          background-image: url("../../assets/images/05point1.png")
        }
        .icon2{
          background-image: url("../../assets/images/05point2.png")
        }
        .icon3{
          background-image: url("../../assets/images/05point3.png")
        }
        .icon4{
          background-image: url("../../assets/images/05point4.png")
        }
        .icon5{
          background-image: url("../../assets/images/05point5.png")
        }
        .icon6{
          background-image: url("../../assets/images/05point6.png")
        }
        .icon7{
          background-image: url("../../assets/images/05point7.png")
        }
        .icon8{
          background-image: url("../../assets/images/05point8.png")
        }
        .icon9{
          background-image: url("../../assets/images/05point9.png")
        }
        &.active{
          .item-text{
            opacity: 1;
          }
          color:$theme-color;
          background-color:#fff;
          border-radius: 4px;
          .icon1{
            background-image: url("../../assets/images/05point1-active.png")
          }
          .icon2{
            background-image: url("../../assets/images/05point2-active.png")
          }
          .icon3{
            background-image: url("../../assets/images/05point3-active.png")
          }
          .icon4{
            background-image: url("../../assets/images/05point4-active.png")
          }
          .icon5{
            background-image: url("../../assets/images/05point5-active.png")
          }
          .icon6{
            background-image: url("../../assets/images/05point6-active.png")
          }
          .icon7{
            background-image: url("../../assets/images/05point7-active.png")
          }
          .icon8{
            background-image: url("../../assets/images/05point8-active.png")
          }
          .icon9{
            background-image: url("../../assets/images/05point9-active.png")
          }
        }
      }
    }
    .content{
      float: left;
      /*
      @media screen and (min-width: $min-width) and(max-width: 1200px) {
        .item-img{
          width: 400px;
        }
      }*/
      .item-img{
        transform:translate(-40px, -40px) scale(0.75);
      }
    }
  }

}
.slide-enter-active,.slide-leave-active{
  transition: opacity .6s, transform .6s;
}
.slide-enter,.slide-leave-to{
  opacity: 0;
  transform: translate(-40px, 60px) scale(0.75) !important;
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexpartFive.vue